export default {
  header: {
    'hideMenuBar': 'Menüsor elrejtése',
    'showMenuBar': 'Menüsor megjelenítése'
  }
}
